<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入名称"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="records"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="10"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="10">
      </el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        min-width="10"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="identityNo"
        label="身份证号"
        min-width="20"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="occupation"
        label="职业"
        show-overflow-tooltip
        min-width="10"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="住址"
        show-overflow-tooltip
        min-width="30"
      ></el-table-column>
      <el-table-column
        prop="politicalityName"
        label="政治面貌"
        show-overflow-tooltip
        min-width="10"
      ></el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        show-overflow-tooltip
        min-width="10"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 'UnRealVerifed'" type="primary"
            >未认证</el-tag
          >
          <el-tag v-if="scope.row.state == 'Unapproved'" type="warning"
            >待审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approved'" type="success"
            >已审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Rejected'" type="danger"
            >已驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="时间"
        show-overflow-tooltip
        min-width="20"
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="实名认证-编辑"
      v-if="currentUser"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="realName">
              <el-input
                v-model="editForm.realName"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="identityNo">
              <el-input
                v-model="editForm.identityNo"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="职业" prop="occupation">
              <el-input
                v-model="editForm.occupation"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌" prop="politicality">
              <el-select
                v-model="editForm.politicality"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in politicalityType"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="住址" prop="address">
              <el-input
                v-model="editForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="认证理由" prop="reason">
              <el-input
                v-model="editForm.reason"
                type="textarea"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="实名认证-新增"
      v-if="currentUser"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="realName">
              <el-input
                v-model="addForm.realName"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="identityNo">
              <el-input
                v-model="addForm.identityNo"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="职业" prop="occupation">
              <el-input
                v-model="addForm.occupation"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌" prop="politicality">
              <el-select
                v-model="addForm.politicality"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in politicalityType"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="住址" prop="address">
              <el-input
                v-model="addForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="认证理由" prop="reason">
              <el-input
                v-model="addForm.reason"
                type="textarea"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          :disabled="
            currentUser.realVerifyState != 'UnRealVerifed' &&
            currentUser.realVerifyState != 'Rejected'
          "
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  queryRealVerifyListPage,
  approveRealVerify,
  saveRealVerify,
  getChildDictionary,
  getUserByToken,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { DictEnum, RealVerifyStateEnum } from "../../api/enum";

export default {
  components: { Toolbar },
  data() {
    return {
      currentUser: null,
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      politicalityType: [],
      records: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        realName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          { max: 50, message: "姓名最长不能超过50个字符", trigger: "blur" },
        ],
        identityNo: [
          { required: true, message: "身份证号不能为空", trigger: "blur" },
          { max: 18, message: "身份证号最长不能超过18个字符", trigger: "blur" },
        ],
        occupation: [
          { required: true, message: "职业不能为空", trigger: "blur" },
          { max: 50, message: "职业最长不能超过50个字符", trigger: "blur" },
        ],
        address: [
          { max: 200, message: "住址最长不能超过200个字符", trigger: "blur" },
        ],
        reason: [
          { max: 200, message: "住址最长不能超过200个字符", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        realName: "",
        identityNo: "",
        occupation: "",
        address: "",
        politicality: "",
        reason: "",
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        realName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          { max: 50, message: "姓名最长不能超过50个字符", trigger: "blur" },
        ],
        identityNo: [
          { required: true, message: "身份证号不能为空", trigger: "blur" },
          { max: 18, message: "身份证号最长不能超过18个字符", trigger: "blur" },
        ],
        occupation: [
          { required: true, message: "职业不能为空", trigger: "blur" },
          { max: 50, message: "职业最长不能超过50个字符", trigger: "blur" },
        ],
        address: [
          { max: 200, message: "住址最长不能超过200个字符", trigger: "blur" },
        ],
        reason: [
          { max: 200, message: "住址最长不能超过200个字符", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        realName: "",
        identityNo: "",
        occupation: "",
        address: "",
        politicality: "",
        reason: "",
      },
    };
  },
  methods: {
    initPoliticalityType() {
      getChildDictionary({ code: DictEnum.PoliticalityType }).then((res) => {
        if (res.data.isSuccess) {
          this.politicalityType = res.data.response;
        }
      });
    },
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    handleQuery() {
      this.listLoading = true;
      //NProgress.start();
      queryRealVerifyListPage(this.filter).then((res) => {
        this.pageModel = res.data.response;
        this.records = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //审核
    handleApprove() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要审核的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.state != "Unapproved") {
        this.$message({
          message: "该数据已审核过！",
          type: "error",
        });
        return;
      }
      this.$prompt("备注", "审核", {
        confirmButtonText: "确定",
      })
        .then(({ value }) => {
          this.listLoading = true;
          //NProgress.start();
          let para = {
            state: RealVerifyStateEnum.Approved,
            id: row.id,
            remark: value,
          };
          approveRealVerify(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "审核成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch((action) => {});
    },
    //驳回
    handleReject() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要驳回的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.state != "Unapproved") {
        this.$message({
          message: "该数据已审核过！",
          type: "error",
        });
        return;
      }
      this.$prompt("备注", "驳回", {
        confirmButtonText: "驳回",
      })
        .then(({ value }) => {
          this.listLoading = true;
          //NProgress.start();
          let para = {
            state: RealVerifyStateEnum.Rejected,
            id: row.id,
            remark: value,
          };
          approveRealVerify(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "驳回成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch((action) => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.updateCurrentUserInfo();
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.updateCurrentUserInfo();
      this.addFormVisible = true;
      this.addForm = {
        realName: "",
        identityNo: "",
        occupation: "",
        address: "",
        politicality: "",
        reason: "",
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            saveRealVerify(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            saveRealVerify(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    updateCurrentUserInfo() {
      getUserByToken({
        token: window.localStorage.Token,
      }).then((res) => {
        if (res.isSuccess) {
          this.currentUser = res.response;
          window.localStorage.user = JSON.stringify(res.response);
        }
      });
    },
  },
  mounted() {
    this.currentUser = this.getCurrentUser();
    this.initPoliticalityType();
    this.handleQuery();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
